import {
  BracketsCurly,
  Car,
  Cube,
  FilmStrip,
  GameController,
  Layout,
  MagicWand,
  MapTrifold,
  MusicNotes,
  PuzzlePiece,
  Swatches,
} from "@phosphor-icons/react";
import type { CategorySlug } from "@/api/types";
import { CATEGORY_LABELS } from "@/lib/categories";

/**
 * Grouping is presentational only — every category is a peer in the data model.
 * The four groups give the eleven-row nav a readable rhythm and say something
 * about what each category is for: the 3D anchor, interactive behaviour,
 * world-building, then presentation.
 */
export type CategoryGroup = "anchor" | "interactive" | "world" | "presentation";

export const MARKETPLACE_CATEGORIES: {
  slug: CategorySlug;
  label: string;
  group: CategoryGroup;
  Icon: typeof Cube;
}[] = [
  { slug: "3d", label: CATEGORY_LABELS["3d"], group: "anchor", Icon: Cube },

  { slug: "systems", label: CATEGORY_LABELS.systems, group: "interactive", Icon: GameController },
  { slug: "vehicles", label: CATEGORY_LABELS.vehicles, group: "interactive", Icon: Car },
  { slug: "scripts", label: CATEGORY_LABELS.scripts, group: "interactive", Icon: BracketsCurly },

  { slug: "materials", label: CATEGORY_LABELS.materials, group: "world", Icon: Swatches },
  { slug: "plugins", label: CATEGORY_LABELS.plugins, group: "world", Icon: PuzzlePiece },
  { slug: "maps", label: CATEGORY_LABELS.maps, group: "world", Icon: MapTrifold },

  { slug: "ui", label: CATEGORY_LABELS.ui, group: "presentation", Icon: Layout },
  { slug: "vfx", label: CATEGORY_LABELS.vfx, group: "presentation", Icon: MagicWand },
  { slug: "audio", label: CATEGORY_LABELS.audio, group: "presentation", Icon: MusicNotes },
  { slug: "animations", label: CATEGORY_LABELS.animations, group: "presentation", Icon: FilmStrip },
];

/** Every category slug, in navigation order. The single source the API and router validate against. */
export const CATEGORY_SLUGS: CategorySlug[] = MARKETPLACE_CATEGORIES.map((category) => category.slug);

export function marketplaceCategoryLabel(category?: CategorySlug) {
  return MARKETPLACE_CATEGORIES.find((item) => item.slug === category)?.label;
}
